import { createContext, useContext } from "react";

const EmployeeIdContext = createContext<string | undefined>(undefined);

export const WidgetsEmployeeIdProvider = ({
  children,
  employeeId,
}: {
  children: React.ReactNode;
  employeeId: string | null | undefined;
}) => {
  return (
    <EmployeeIdContext.Provider value={employeeId ?? undefined}>
      {children}
    </EmployeeIdContext.Provider>
  );
};

export const useEmployeeId = () => {
  return useContext(EmployeeIdContext);
};
